import Vue from 'vue'
import VueRouter from 'vue-router'

import Error404 from '../views/404.vue'

import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ForgotPasswordConfirm from '../views/ForgotPasswordConfirm.vue'
import ResetPassword from '../views/ResetPassword.vue'
import SuccessResetPassword from '../views/SuccessResetPassword.vue'

// // MyOrder
import DeliveryIndex from '@/views/my-order/Index.vue'
import DeliveryAdd from '@/views/my-order/Form.vue'

import SettingForm from '@/views/setting/Form.vue'

import ReportIndex from '@/views/report/Index.vue'

Vue.use(VueRouter)

const routes = [{
        path: 'main',
        component: () =>
            import ('../layouts/Main.vue'),
        children: [
            {
                path: '/404',
                name: 'Error404',
                component: Error404,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/my-order',
                name: 'DeliveryIndex',
                component: DeliveryIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/my-order/add',
                name: 'DeliveryAdd',
                component: DeliveryAdd,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/report',
                name: 'ReportIndex',
                component: ReportIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/setting',
                name: 'SettingForm',
                component: SettingForm,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '',
        component: () =>
            import ('../layouts/FullPage.vue'),
        children: [
            {
                path: '/',
                name: 'Login',
                component: Login,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/register',
                name: 'Register',
                component: Register,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/lupa-password',
                name: 'ForgotPassword',
                component: ForgotPassword,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/lupa-password-confirm',
                name: 'ForgotPasswordConfirm',
                component: ForgotPasswordConfirm,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/reset-password',
                name: 'ResetPassword',
                component: ResetPassword,
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: '/success-reset-password',
                name: 'SuccessResetPassword',
                component: SuccessResetPassword,
                meta: {
                    requiresAuth: false
                }
            }
        ]
    },
    {
        path: '*',
        redirect: '/404'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkExactActiveClass: "active",
    linkActiveClass: "active"
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('token') && localStorage.getItem('token') != 'null') {
            next()
        } else {
            next({
                path: '/'
            })
        }
    } else {
        next()
    }
})

export default router